import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, getConfig } from "../../../../utils";

export const addBranchCourse = createAsyncThunk('addBranchCourse', async (data) => {
    try {
        const res = await axios({
            method: 'POST',
            url: getConfig.API_URL + 'branch_course',
            data: {
                "institute_id": data?.values?.instituteId,
                "institute_branch_id": data?.values?.instituteBranchId,
                "course_id": data?.values?.courseId,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})
